import { AfterViewInit, Component, ElementRef, NgZone, ViewChild, inject } from '@angular/core';
import { V3dBaseViewComponent } from '../v3d-base-view/v3d-base-view.component';
import { ComponentHandlerProvider } from '../../v3d-components/handlers/component-handler-provider';
import { QmodelThreejsCreatorService } from '../../providers/qmodel-threejs-creator.service';
import { Visualize3dObjectEventService } from '../../providers/visualize3d-object-event.service';
import { V3dPerspectiveSceneManager } from '../../scene/v3d-perspective-scene-manager';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'v3d-perspective-view',
  templateUrl: '../v3d-base-view/v3d-base-view.component.html',
  styleUrls: ['../v3d-base-view/v3d-base-view.component.css'],
  standalone: false,
})
export class V3dPerspectiveViewComponent extends V3dBaseViewComponent<V3dPerspectiveSceneManager> implements AfterViewInit {
  @ViewChild('threeContainer', { static: true }) container: ElementRef<HTMLElement>;

  constructor() {
    const componentHandlerProvider = inject(ComponentHandlerProvider);
    const qmodelThreeJsCreatorService = inject(QmodelThreejsCreatorService);
    const visualize3dObjectEventService = inject(Visualize3dObjectEventService);
    const zone = inject(NgZone);

    super(componentHandlerProvider, qmodelThreeJsCreatorService, visualize3dObjectEventService, zone);
  }
}
